import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2add5145"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "q-my-lg horizontal-line"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "super-offers__title-wrap flex items-center justify-between q-mb-lg" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle" }, "Best choice", -1))
const _hoisted_5 = { class: "q-gutter-sm" }
const _hoisted_6 = { class: "super-offer__img-wrap flex items-center justify-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "super-offer__content bg-white" }
const _hoisted_9 = { class: "super-offer__header flex items-center" }
const _hoisted_10 = { class: "super-offer__name text-weight-bolder q-mr-sm" }
const _hoisted_11 = { class: "super-offer__reward text-weight-bolder" }
const _hoisted_12 = { class: "relative-position q-ml-sm" }
const _hoisted_13 = {
  key: 0,
  class: "question"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line" }, null, -1))
const _hoisted_15 = { class: "super-offer__geo flex items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "q-mr-md" }, "Geo:", -1))
const _hoisted_17 = { class: "flex q-gutter-xs q-mr-md" }
const _hoisted_18 = ["alt", "src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line" }, null, -1))
const _hoisted_20 = { class: "super-offer__type flex" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "q-mr-md" }, "Conversion type:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.superOffers.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.superOffers.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_btn, {
                square: "",
                icon: _ctx.heroOutline24ChevronLeft,
                size: "xs",
                padding: "xs",
                unelevated: "",
                style: {"color":"var(--gray-raven)"},
                class: "bg-white",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.carousel.previous()))
              }, null, 8, ["icon"]),
              _createVNode(_component_q_btn, {
                square: "",
                icon: _ctx.heroOutline24ChevronRight,
                size: "xs",
                padding: "xs",
                unelevated: "",
                style: {"color":"var(--gray-raven)"},
                class: "bg-white",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.carousel.next()))
              }, null, 8, ["icon"])
            ])
          ]),
          _createVNode(_component_q_carousel, {
            modelValue: _ctx.slide,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.slide) = $event)),
            "transition-prev": "slide-right",
            "transition-next": "slide-left",
            swipeable: "",
            animated: "",
            infinite: "",
            "control-color": "primary",
            height: "144px",
            class: "bg-transparent shadow-none rounded-borders super-offers__carousel",
            ref: "carousel"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prepareData, (superArray, index1) => {
                return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                  name: index1 + 1,
                  class: "super-offers__wrap",
                  key: index1
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(superArray, (row, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["super-offer col", { 'q-mr-md': superArray.length - 1 != index }])
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_router_link, {
                            class: "flex column items-center justify-center",
                            to: { name: 'offer', params: { id: row.id } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                width: "100",
                                height: "50",
                                class: "super-offer__img",
                                src: `${_ctx.storageUrl + '/' + row.image}`
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(row.name), 1),
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getRewardAmounts([
                    ...row.commonRewards,
                    ...row.affiliateRewards,
                  ])), 1),
                            _createElementVNode("div", _hoisted_12, [
                              (
                    [...row.commonRewards, ...row.affiliateRewards].length > 1
                  )
                                ? (_openBlock(), _createElementBlock("sup", _hoisted_13, "?"))
                                : _createCommentVNode("", true),
                              (
                    [...row.commonRewards, ...row.affiliateRewards].length > 1
                  )
                                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                    key: 1,
                                    anchor: "top left",
                                    self: "top left",
                                    class: "q-tooltip custom-tooltip"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getRewards([...row.commonRewards, ...row.affiliateRewards])), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row['rewards'][0]['geos'], (geo, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createElementVNode("img", {
                                    height: "10",
                                    width: "15",
                                    alt: geo.isoCode,
                                    src: 
                      `http://purecatamphetamine.github.io/country-flag-icons/3x2/${geo.isoCode}.svg`
                    
                                  }, null, 8, _hoisted_18)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("strong", null, _toDisplayString(_ctx.rewardTypes[row['rewards'][0]['type']]), 1)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}